var map = {
	"./404.svg": "./src/icons/svg/404.svg",
	"./Information-change.svg": "./src/icons/svg/Information-change.svg",
	"./Interface.svg": "./src/icons/svg/Interface.svg",
	"./abnormal.svg": "./src/icons/svg/abnormal.svg",
	"./account-recovery.svg": "./src/icons/svg/account-recovery.svg",
	"./agent-lien.svg": "./src/icons/svg/agent-lien.svg",
	"./agentxunijie.svg": "./src/icons/svg/agentxunijie.svg",
	"./appointment.svg": "./src/icons/svg/appointment.svg",
	"./assagpick.svg": "./src/icons/svg/assagpick.svg",
	"./assagwarn.svg": "./src/icons/svg/assagwarn.svg",
	"./assigned.svg": "./src/icons/svg/assigned.svg",
	"./automatic-generation.svg": "./src/icons/svg/automatic-generation.svg",
	"./bill-management.svg": "./src/icons/svg/bill-management.svg",
	"./black-list.svg": "./src/icons/svg/black-list.svg",
	"./bookwarn.svg": "./src/icons/svg/bookwarn.svg",
	"./broadcast.svg": "./src/icons/svg/broadcast.svg",
	"./bug.svg": "./src/icons/svg/bug.svg",
	"./capp.svg": "./src/icons/svg/capp.svg",
	"./car-label.svg": "./src/icons/svg/car-label.svg",
	"./car-manage.svg": "./src/icons/svg/car-manage.svg",
	"./car.svg": "./src/icons/svg/car.svg",
	"./chart.svg": "./src/icons/svg/chart.svg",
	"./circulation.svg": "./src/icons/svg/circulation.svg",
	"./city-compliance.svg": "./src/icons/svg/city-compliance.svg",
	"./clipboard.svg": "./src/icons/svg/clipboard.svg",
	"./company-information-management.svg": "./src/icons/svg/company-information-management.svg",
	"./component.svg": "./src/icons/svg/component.svg",
	"./configu-ration.svg": "./src/icons/svg/configu-ration.svg",
	"./configuration.svg": "./src/icons/svg/configuration.svg",
	"./contract-management.svg": "./src/icons/svg/contract-management.svg",
	"./coupon.svg": "./src/icons/svg/coupon.svg",
	"./customer-service.svg": "./src/icons/svg/customer-service.svg",
	"./dashboard.svg": "./src/icons/svg/dashboard.svg",
	"./data-board.svg": "./src/icons/svg/data-board.svg",
	"./data-review.svg": "./src/icons/svg/data-review.svg",
	"./data.svg": "./src/icons/svg/data.svg",
	"./distribute-leaflets.svg": "./src/icons/svg/distribute-leaflets.svg",
	"./documentation.svg": "./src/icons/svg/documentation.svg",
	"./drag.svg": "./src/icons/svg/drag.svg",
	"./driver-registration.svg": "./src/icons/svg/driver-registration.svg",
	"./driver-train.svg": "./src/icons/svg/driver-train.svg",
	"./driver-training-management.svg": "./src/icons/svg/driver-training-management.svg",
	"./driver.svg": "./src/icons/svg/driver.svg",
	"./driving-track.svg": "./src/icons/svg/driving-track.svg",
	"./edit.svg": "./src/icons/svg/edit.svg",
	"./education.svg": "./src/icons/svg/education.svg",
	"./email.svg": "./src/icons/svg/email.svg",
	"./end-fence.svg": "./src/icons/svg/end-fence.svg",
	"./end.svg": "./src/icons/svg/end.svg",
	"./epidemic-prevention.svg": "./src/icons/svg/epidemic-prevention.svg",
	"./example.svg": "./src/icons/svg/example.svg",
	"./excel.svg": "./src/icons/svg/excel.svg",
	"./exit-fullscreen.svg": "./src/icons/svg/exit-fullscreen.svg",
	"./eye-open.svg": "./src/icons/svg/eye-open.svg",
	"./eye.svg": "./src/icons/svg/eye.svg",
	"./face.svg": "./src/icons/svg/face.svg",
	"./fast-generation.svg": "./src/icons/svg/fast-generation.svg",
	"./form.svg": "./src/icons/svg/form.svg",
	"./foundation-fence.svg": "./src/icons/svg/foundation-fence.svg",
	"./fullscreen.svg": "./src/icons/svg/fullscreen.svg",
	"./geography-fencing.svg": "./src/icons/svg/geography-fencing.svg",
	"./gift.svg": "./src/icons/svg/gift.svg",
	"./group-chat.svg": "./src/icons/svg/group-chat.svg",
	"./guide.svg": "./src/icons/svg/guide.svg",
	"./health-code.svg": "./src/icons/svg/health-code.svg",
	"./heat.svg": "./src/icons/svg/heat.svg",
	"./high-speed.svg": "./src/icons/svg/high-speed.svg",
	"./history.svg": "./src/icons/svg/history.svg",
	"./home.svg": "./src/icons/svg/home.svg",
	"./hot-fence.svg": "./src/icons/svg/hot-fence.svg",
	"./icon.svg": "./src/icons/svg/icon.svg",
	"./imgcode.svg": "./src/icons/svg/imgcode.svg",
	"./international.svg": "./src/icons/svg/international.svg",
	"./language.svg": "./src/icons/svg/language.svg",
	"./lease-contract.svg": "./src/icons/svg/lease-contract.svg",
	"./leasing-company-withdrawal.svg": "./src/icons/svg/leasing-company-withdrawal.svg",
	"./leasing-company.svg": "./src/icons/svg/leasing-company.svg",
	"./lie.svg": "./src/icons/svg/lie.svg",
	"./limit-order.svg": "./src/icons/svg/limit-order.svg",
	"./link.svg": "./src/icons/svg/link.svg",
	"./list.svg": "./src/icons/svg/list.svg",
	"./lock.svg": "./src/icons/svg/lock.svg",
	"./marker.svg": "./src/icons/svg/marker.svg",
	"./market-fence.svg": "./src/icons/svg/market-fence.svg",
	"./marketing.svg": "./src/icons/svg/marketing.svg",
	"./menu.svg": "./src/icons/svg/menu.svg",
	"./message.svg": "./src/icons/svg/message.svg",
	"./model.svg": "./src/icons/svg/model.svg",
	"./money.svg": "./src/icons/svg/money.svg",
	"./mutex.svg": "./src/icons/svg/mutex.svg",
	"./my-hobby.svg": "./src/icons/svg/my-hobby.svg",
	"./nested.svg": "./src/icons/svg/nested.svg",
	"./no-quotation.svg": "./src/icons/svg/no-quotation.svg",
	"./nucleic.svg": "./src/icons/svg/nucleic.svg",
	"./operation-records.svg": "./src/icons/svg/operation-records.svg",
	"./order-title.svg": "./src/icons/svg/order-title.svg",
	"./org.svg": "./src/icons/svg/org.svg",
	"./outbound.svg": "./src/icons/svg/outbound.svg",
	"./palcebook.svg": "./src/icons/svg/palcebook.svg",
	"./password.svg": "./src/icons/svg/password.svg",
	"./pdf.svg": "./src/icons/svg/pdf.svg",
	"./people.svg": "./src/icons/svg/people.svg",
	"./peoples.svg": "./src/icons/svg/peoples.svg",
	"./qq.svg": "./src/icons/svg/qq.svg",
	"./quality-inspection-list.svg": "./src/icons/svg/quality-inspection-list.svg",
	"./quality-test.svg": "./src/icons/svg/quality-test.svg",
	"./query.svg": "./src/icons/svg/query.svg",
	"./reassignment.svg": "./src/icons/svg/reassignment.svg",
	"./recording.svg": "./src/icons/svg/recording.svg",
	"./rectification.svg": "./src/icons/svg/rectification.svg",
	"./red-envelopes.svg": "./src/icons/svg/red-envelopes.svg",
	"./rehearsal.svg": "./src/icons/svg/rehearsal.svg",
	"./reverse-geofenc.svg": "./src/icons/svg/reverse-geofenc.svg",
	"./risk-center.svg": "./src/icons/svg/risk-center.svg",
	"./riskfactor.svg": "./src/icons/svg/riskfactor.svg",
	"./role.svg": "./src/icons/svg/role.svg",
	"./search.svg": "./src/icons/svg/search.svg",
	"./server-configure.svg": "./src/icons/svg/server-configure.svg",
	"./shopping.svg": "./src/icons/svg/shopping.svg",
	"./size.svg": "./src/icons/svg/size.svg",
	"./skill.svg": "./src/icons/svg/skill.svg",
	"./standard.svg": "./src/icons/svg/standard.svg",
	"./star.svg": "./src/icons/svg/star.svg",
	"./start.svg": "./src/icons/svg/start.svg",
	"./statistics.svg": "./src/icons/svg/statistics.svg",
	"./stock.svg": "./src/icons/svg/stock.svg",
	"./system-log.svg": "./src/icons/svg/system-log.svg",
	"./system-management.svg": "./src/icons/svg/system-management.svg",
	"./tab.svg": "./src/icons/svg/tab.svg",
	"./table.svg": "./src/icons/svg/table.svg",
	"./task-management.svg": "./src/icons/svg/task-management.svg",
	"./theme.svg": "./src/icons/svg/theme.svg",
	"./third-party.svg": "./src/icons/svg/third-party.svg",
	"./total.svg": "./src/icons/svg/total.svg",
	"./transport.svg": "./src/icons/svg/transport.svg",
	"./tree-table.svg": "./src/icons/svg/tree-table.svg",
	"./tree.svg": "./src/icons/svg/tree.svg",
	"./triggerevent.svg": "./src/icons/svg/triggerevent.svg",
	"./turn.svg": "./src/icons/svg/turn.svg",
	"./up-down.svg": "./src/icons/svg/up-down.svg",
	"./user-set.svg": "./src/icons/svg/user-set.svg",
	"./user.svg": "./src/icons/svg/user.svg",
	"./vaccine.svg": "./src/icons/svg/vaccine.svg",
	"./vehicle-conflict.svg": "./src/icons/svg/vehicle-conflict.svg",
	"./violation.svg": "./src/icons/svg/violation.svg",
	"./vip.svg": "./src/icons/svg/vip.svg",
	"./volume-contract.svg": "./src/icons/svg/volume-contract.svg",
	"./wait-channel.svg": "./src/icons/svg/wait-channel.svg",
	"./waiting-list.svg": "./src/icons/svg/waiting-list.svg",
	"./warning.svg": "./src/icons/svg/warning.svg",
	"./wechat.svg": "./src/icons/svg/wechat.svg",
	"./weidu.svg": "./src/icons/svg/weidu.svg",
	"./white-list.svg": "./src/icons/svg/white-list.svg",
	"./workbench.svg": "./src/icons/svg/workbench.svg",
	"./zfb.svg": "./src/icons/svg/zfb.svg",
	"./zip.svg": "./src/icons/svg/zip.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/icons/svg sync \\.svg$";